import DetailCard from '../shared/DetailCard';
import DetailRow from '../shared/DetailRow';

interface FundDetailsProps {
  amount: number;
  transactionId?: string;
  createdBy?: { name: string; accountId: string };
}

const FundDetails = ({
  amount,
  transactionId,
  createdBy,
}: FundDetailsProps) => (
  <DetailCard>
    <DetailRow label="Amount" value={`${amount} HBAR`} />
    {transactionId && <DetailRow label="Transaction ID" value={transactionId} />}
    {createdBy && (
      <DetailRow
        label="Created by"
        value={createdBy.name ? `${createdBy.name} (${createdBy.accountId})` : createdBy.accountId}
      />
    )}
  </DetailCard>
);

export default FundDetails;
